/* eslint-disable custom-portal-rules/no-restricted-imports */

import type { Color } from "@material-ui/core";

// Base colors
export const cyan = "#0D80D8";
export const navy = "#0F2535";
export const green = "#00B065";
export const white = "#ffffff";
export const black = "#000000";
export const transparent = "transparent";

// Tints
export const cyan10 = "#E9EDF2";
export const cyan20 = "#ecf5fb";
export const cyan30 = "#86CAFF"; //86CAFF
export const cyan40 = "#3679AC";
export const cyan50 = "#0A67B1";
export const cyan60 = "#053B62";
export const cyan70 = "#3C5A71";

export const navy10 = "#E3EEF6";
export const navy20 = "#C3CEDC";
export const navy30 = "#8B9EAC";
export const navy40 = "#6D7D87";
export const navy50 = "#0E3655"; //324553
export const navy60 = "#13354F"; //273B49
export const navy70 = "#112E44"; //1B303F
export const navy90 = "#07121A"; //1B303F

export const grey10 = "#FAFAFA";
export const grey20 = "#F2F2F2";
export const grey30 = "#E0E0E0";
export const grey40 = "#BCBCBC";
export const grey50 = "#9e9e9e";
export const grey60 = "#666666";
export const grey70 = "#333333";

export const green10 = "#F1F9F1";
export const green20 = "#A9D4A9";
export const green30 = "#5EAE5E";
export const green40 = "#497F49";
export const green50 = "#449744";
export const green60 = "#23513D";
export const green70 = "#173628";

// Additional colors
export const red = "#db4437";
export const red10 = "#f8e8e6"; //f8e8e6
export const red20 = "#D8655E";
export const red30 = "#F2827B";
export const red40 = "#C14136";
export const red50 = "#8F5652";
export const red60 = "#4C2D35";
export const red70 = "#311A20";

export const orange = "#fb8c00";
export const orange10 = "#fcf1e2";
export const orange20 = "#DAA25B";
export const orange30 = "#DC953A";
export const orange40 = "#423113";

export const purple = "#441c7f";
export const purple10 = "#f4ebf9";
export const purple20 = "#C8B3D3";
export const purple30 = "#BD90FF";
export const purple40 = "#4E3574";

export const blue = "#0878D1";
export const blue10 = "#E6F1FA";
export const blue20 = "#A0CFF4";
export const blue30 = "#0C3D63";

export const yellow = "#DECB6B";
export const highlightText = "#FFFF99";
export const highlightTextBackground = "black";

// Color object for #2f93e0 along with shades and accent colors
export const octopusBlue: Color = {
    50: "#ecf5fb",
    100: "#c1dff6",
    200: "#97c9f0",
    300: "#6db3e9",
    400: "#4ea3e5",
    500: "#2f93e0",
    600: "#2a8bdc",
    700: "#2380d8",
    800: "#1d76d3",
    900: "#1264cb",
    A100: "#fafcff",
    A200: "#c7deff",
    A400: "#94bfff",
    A700: "#7ab0ff",
};

// Color object for #48b350 along with shades and accent colors
export const octopusGreen: Color = {
    50: "#e9f6ea",
    100: "#c8e8cb",
    200: "#a4d9a8",
    300: "#7fca85",
    400: "#63be6a",
    500: "#48b350",
    600: "#41ac49",
    700: "#38a340",
    800: "#309a37",
    900: "#218b27",
    A100: "#c8ffca",
    A200: "#95ff9a",
    A400: "#62ff69",
    A700: "#48ff51",
};

export const diffAddedBackground = "#e6ffed";
export const diffWordAddedBackground = "#acf2bd";
export const diffRemovedBackground = "#ffeef0";
export const diffWordRemovedBackground = "#fdb8c0";
export const diffInfoBackground = blue10;

export const shadow40 = "rgba(0, 0, 0, 0.4)";
export const shadow60 = "rgba(0, 0, 0, 0.6)";
export const shadow20 = "rgba(0, 0, 0, 0.2)";
export const shadow12 = "rgba(0, 0, 0, 0.12)";
export const shadow14 = "rgba(0, 0, 0, 0.14)";
export const shadow25 = "rgba(0, 0, 0, 0.25)";
export const shadow22 = "rgba(0, 0, 0, 0.22)";
export const shadow34 = "rgba(0, 0, 0, 0.34)";
